import { apiSlice } from "../api/apiSlice";

export const videosAPI = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getVideos: builder.query({
      query: () => "/videos",
    }),
    getVideo: builder.query({
      query: (id) => `/videos/${id}`,
    }),
    addVideo: builder.mutation({
      query: (data) => ({
        url: "/videos",
        method: "POST",
        body: data,
      }),

      async onQueryStarted(data, { queryFulfilled, dispatch }) {
        try {
          const addResult = await queryFulfilled;
          dispatch(
            apiSlice.util.updateQueryData("getVideos", undefined, (draft) => {
              draft.push(addResult.data);
            })
          );
        } catch (error) {
          console.error("Something Went Wrong!");
          console.error(error);
        }
      },
    }),
    editVideo: builder.mutation({
      query: ({ id, data }) => ({
        url: `/videos/${id}`,
        method: "PATCH",
        body: data,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const editResult = await queryFulfilled;

          //Update Tasks Cache
          await dispatch(
            apiSlice.util.updateQueryData("getVideos", undefined, (draft) => {
              let target = draft.findIndex(
                (video) => Number(video.id) === arg.id
              );
              draft[target] = editResult.data;
            })
          );

          //Update Task Cache for edit
          const id = String(arg.id);
          await dispatch(
            apiSlice.util.updateQueryData("getVideo", id, (draft) => {
              draft.title = editResult.data.title;
              draft.description = editResult.data.description;
              draft.url = editResult.data.url;
              draft.views = editResult.data.views;
              draft.duration = editResult.data.duration;
              draft.createdAt = editResult.data.createdAt;
            })
          );
        } catch (error) {
          console.error("Something went Wrong!");
        }
      },
    }),
    deleteVideo: builder.mutation({
      query: (id) => ({
        url: `videos/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        const deleteResult = dispatch(
          apiSlice.util.updateQueryData("getVideos", undefined, (draft) => {
            const targetIndex = draft.findIndex(
              (video) => Number(video.id) === arg
            );
            draft.splice(targetIndex, 1);
          })
        );

        try {
          const result = await queryFulfilled;
          if (result.meta.response.status === 200) {
            console.log("Successfully Deleted!");
          }
        } catch (error) {
          deleteResult.undo();
          console.log(error);
        }
      },
    }),
  }),
});

export const {
  useGetVideosQuery,
  useGetVideoQuery,
  useAddVideoMutation,
  useEditVideoMutation,
  useDeleteVideoMutation,
} = videosAPI;
